!(function () {
  const init = function () {
    const swiperEls = document.querySelectorAll('.collections-preview-swiper');
    const swiperParams = {
      slidesPerView: 2,
      spaceBetween: 12,
      grid: {
        rows: 2,
      },
      grabCursor: true,
      scrollbar: {
        draggable: true,
      },
      injectStyles: [
        `
            :host .swiper {
              padding-bottom: 1.5rem;
            }
            :host .swiper-scrollbar-drag {
              cursor:grab;
            }
            `,
      ],
      breakpoints: {
        640: {
          slidesPerView: 3,
        },
        1280: {
          slidesPerView: 4,
        },
        1536: {
          slidesPerView: 6,
          grid: {
            rows: 3,
          },
        },
      },
      on: {
        init() {
          // ...
        },
      },
    };

    swiperEls.forEach((swiperEl) => {
      swiperEl.classList.remove('grid', 'grid-cols-2', 'lg:grid-cols-4', 'xl:grid-cols-6', 'gap-3');
      swiperEl.classList.add('h-full');
      Object.assign(swiperEl, swiperParams);
      swiperEl.initialize();
    });
  };

  //init when DOM ready
  if (/complete|interactive|loaded/.test(document.readyState)) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
